/* istanbul ignore file*/
import {
    OVERLAY_ANIMATION_SLIDE,
    IOverlayBusinessLogic,
    Overlay,
    createOverlay,
} from '@vfde-brix/ws10/overlay';
import { NAME_OVERLAY } from '../constants';
import { getFiberObject, setFiberProperty } from '../util/cms';
import { FORM_SUGGEST_INPUT_CLASSNAME_INPUT_FOCUSED } from '@vfde-brix/ws10/form-suggest-input';
import { deleteCaptchaForAddress } from '@vfde-sails/avc-core';
import { handleButtonVisibility, updateArrowUp } from './sticky-button';
const SCROLL_CLASS = 'ws10-overlay-fix';

/**
 * Scrolls the window to the top if there is an active (focused) FormSuggestInput.
 * Attach this to the window.visualViewport's resize event,
 * which is fired when the virtual keyboard opens on mobile,
 * so it fixes a bug where a FormSuggestInput scrolls out of the viewport when it becomes focused
 */
const handleResize = () => {
    const activeSuggestInputs = document.getElementsByClassName(FORM_SUGGEST_INPUT_CLASSNAME_INPUT_FOCUSED);

    if (activeSuggestInputs.length) {
        window.scrollTo(0, 0);
    }
};

/**
 * Mount overlay component
 */
export const mountOverlayComponent = (onCloseHandler: Function) => {
    const overlayWrapper = document.createElement('div');
    const business: IOverlayBusinessLogic = {
        onOpen: () => {
            document.documentElement.classList.add(SCROLL_CLASS);
            document.body.classList.add(SCROLL_CLASS);

            window.visualViewport?.addEventListener('resize', handleResize);
        },
        onClose: () => {
            /**
             * Add this class to the html and body tags to fix
             * the overflow: hidden not taking effect bug on iOS devices.
             * The class itself contains media queries to be mobile-only,
             * so it has no effect on bigger screens
             */
            document.documentElement.classList.remove(SCROLL_CLASS);
            document.body.classList.remove(SCROLL_CLASS);
            window.visualViewport?.removeEventListener('resize', handleResize);
            // handle when customer exits from the seamless flow
            deleteCaptchaForAddress();
            handleButtonVisibility();
            onCloseHandler();
            updateArrowUp();
        },
    };

    document.body.appendChild(overlayWrapper);

    const overlay = createOverlay(overlayWrapper, {
        optPaddingLayout: true,
        optAnimation: OVERLAY_ANIMATION_SLIDE,
        business,
    });

    setFiberProperty(NAME_OVERLAY, overlay);

    return overlay;
};

/**
 * Opens or closes the overlay, by default opens it
 *  @param isOpen true: opens the ovelay , false: closes it.
 */
export const setOverlayVisiblity = (isOpen: boolean = true) => {
    const overlay: Overlay | undefined = getFiberObject()?.overlay;

    isOpen ? overlay?.open() : overlay?.close();
};
